export default "__VITE_ASSET__BGXwZMB4__"